// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__16vQC","savePackageButton":"ClientWallet_savePackageButton__EsGFA"};